import React from "react";
import {Route, Routes} from "react-router-dom";
import {SimpleDrawPage} from "@/pages/simple-draw";

export const SimpleDrawRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<SimpleDrawPage />} />
        </Routes>
    );
};
